import { SecondaryTrackConfig } from '@cxstudio/conversation/shapes/secondary-track-config.class';

export class PredefinedMetricTrack extends SecondaryTrackConfig {

	dataFilter = data => this.enrichment?.hasValue(data);

}